import React from 'react'
import { IconEnvelope, IconPhone, IconCheck } from './Icons'

const About = ({ content }) => {
    return (
        <div>
            <section id="about" className="about-area rel z-1 pt-110 pb-70">
                <div className="container">
                    <div className="row gap-100 align-items-center">
                        <div className="col-lg-7">
                            <div className="about-content-part rel z-2 rmb-55">
                                <div className="section-title mb-35 wow fadeInUp delay-0-2s">
                                    <span className="sub-title mb-15" style={{ color: '#38BDF8', fontWeight: 600 }}>About Me</span>
                                    <h2 style={{ color: '#F8FAFC', fontWeight: 800 }}>Professional <span>Problem Solutions</span> For Full-Stack Software Engineering</h2>
                                    <p style={{ color: '#94A3B8', fontSize: '16px', lineHeight: '1.75' }} className="mt-3">
                                        I'm a passionate developer with a strong desire to create functional and visually appealing digital solutions. With {content?.exp_years || '5'} years of experience in the industry, I specialize in building robust web applications, optimizing database structures, and delivering full-stack solutions using MERN stack, Next.js, MySQL, and Python.
                                    </p>
                                </div>

                                {/* Clean SVG Bullet List */}
                                <div className="row g-3 mb-4">
                                    <div className="col-sm-6">
                                        <div className="d-flex align-items-center p-1">
                                            <IconCheck size={18} color="#38BDF8" className="me-2 flex-shrink-0" />
                                            <span style={{ color: '#F8FAFC', fontSize: '15px', fontWeight: 600 }}>Full-Stack Software Engineering</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="d-flex align-items-center p-1">
                                            <IconCheck size={18} color="#38BDF8" className="me-2 flex-shrink-0" />
                                            <span style={{ color: '#F8FAFC', fontSize: '15px', fontWeight: 600 }}>Python & Backend Services</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="d-flex align-items-center p-1">
                                            <IconCheck size={18} color="#38BDF8" className="me-2 flex-shrink-0" />
                                            <span style={{ color: '#F8FAFC', fontSize: '15px', fontWeight: 600 }}>MySQL & Database Architecture</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="d-flex align-items-center p-1">
                                            <IconCheck size={18} color="#38BDF8" className="me-2 flex-shrink-0" />
                                            <span style={{ color: '#F8FAFC', fontSize: '15px', fontWeight: 600 }}>Full-Stack Web Applications</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Executive 2-Column Contact Info Grid */}
                                <div className="row g-3 mt-2 wow fadeInUp delay-0-2s">
                                    <div className="col-sm-6">
                                        <div className="info-box-item d-flex align-items-center p-3 executive-card h-100">
                                            <div className="p-2 rounded-3 me-3 flex-shrink-0" style={{ background: 'rgba(56, 189, 248, 0.12)' }}>
                                                <IconEnvelope size={22} color="#38BDF8" />
                                            </div>
                                            <div className="content overflow-hidden">
                                                <span style={{ color: '#94A3B8', fontSize: '12px', fontWeight: 500 }}>Email Us</span><br />
                                                <a href="mailto:manojparmar6161@gmail.com" style={{ color: '#F8FAFC', textDecoration: 'none', fontWeight: 600, fontSize: '13.5px' }} className="text-truncate d-block">
                                                    manojparmar6161@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="info-box-item d-flex align-items-center p-3 executive-card h-100">
                                            <div className="p-2 rounded-3 me-3 flex-shrink-0" style={{ background: 'rgba(56, 189, 248, 0.12)' }}>
                                                <IconPhone size={22} color="#38BDF8" />
                                            </div>
                                            <div className="content">
                                                <span style={{ color: '#94A3B8', fontSize: '12px', fontWeight: 500 }}>Make A Call</span><br />
                                                <a href="tel:+917038595952" style={{ color: '#F8FAFC', textDecoration: 'none', fontWeight: 600, fontSize: '14px' }}>
                                                    +91 7038595952
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Executive Image Frame */}
                        <div className="col-lg-5">
                            <div className="about-image-part rel z-1 wow fadeInUp delay-0-3s">
                                <div style={{ borderRadius: '24px', overflow: 'hidden', border: '1px solid rgba(255, 255, 255, 0.12)', boxShadow: '0 20px 50px rgba(0,0,0,0.5)' }}>
                                    <img src="assets/images/about/abouts.png" alt="About Me" style={{ width: '100%', height: 'auto', display: 'block' }} />
                                </div>
                                
                                {/* Dark Glass Status Badge */}
                                <div className="executive-card p-3 d-inline-flex align-items-center gap-3" style={{ position: 'absolute', bottom: '20px', left: '20px', right: '20px', background: 'rgba(19, 27, 46, 0.88)', backdropFilter: 'blur(16px)', border: '1px solid rgba(255, 255, 255, 0.15)', borderRadius: '16px' }}>
                                    <img src="assets/images/skills/react.png" alt="React" style={{ width: '32px', height: '32px', objectFit: 'contain' }} />
                                    <div>
                                        <h6 className="m-0" style={{ color: '#F8FAFC', fontSize: '14px', fontWeight: 700 }}>Experienced Senior Engineer</h6>
                                        <span style={{ color: '#38BDF8', fontSize: '12px', fontWeight: 600 }}>5+ Years Full-Stack Expertise</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-lines">
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                </div>
            </section>



        </div>
    )
}

export default About